import Img from "react-cool-img";
let loadingImageUrl = "/assets/loadingImage.webp";
const Image = ({ src, loadingImage = loadingImageUrl, ...rest }) => {
  return <Img src={src} placeholder={loadingImage} {...rest} cache={true} lazy={true} />;
};
export default Image;
